import _ from 'lodash'

const videoServices = {
    YOUTUBE: {
        prepareVideoThumbUrl: buildYoutubeVideoThumbUrl
    },
    VIMEO: {
        prepareVideoThumbUrl: createVimeoVideoThumbRequest
    }
}

const getYouTubePreviewUrl = videoId => `//img.youtube.com/vi/${videoId}/0.jpg`

function getVimeoPreviewUrl(videoId) {
    return `//vimeo.com/api/v2/video/${videoId}.json`
}

function buildYoutubeVideoThumbUrl(videoItem) {
    videoItem.item.imageSrc = getYouTubePreviewUrl(videoItem.item.videoId)
    return null
}

function createVimeoVideoThumbRequest(videoItem, videoNotFoundUrl) {
    if (videoItem.item.imageSrc) {
        return null
    }
    const url = getVimeoPreviewUrl(videoItem.item.videoId)
    return {
        destination: videoItem.path,
        name: 'video thumb',
        url,
        transformFunc: (response, currentValue) => transformVideo(response, currentValue, {videoItem, videoNotFoundUrl})
    }
}

function transformVideo(response, item) {
    const [responseData] = response
    const transformedItem = _.isArray(item) ? findItemWithVideoId(item, responseData.id) : item
    transformedItem.imageSrc = responseData.thumbnail_large

    return transformedItem
}

function findItemWithVideoId(itemArr, videoId) {
    return _.find(itemArr, {videoId: `${videoId}`})
}

function prepareSingleVideoThumbUrl(singleVideoItem, videoNotFoundUrl) {
    if (singleVideoItem.item.videoType) {
        return videoServices[singleVideoItem.item.videoType].prepareVideoThumbUrl(singleVideoItem, videoNotFoundUrl)
    }

    singleVideoItem.imageSrc = videoNotFoundUrl
    return null
}

const handleVideoThumbUrls = ({videoNotFoundUrl}, videoDataItems = []) => _.compact(_.map(videoDataItems, dataItem => prepareSingleVideoThumbUrl(dataItem, videoNotFoundUrl)))

export {
    handleVideoThumbUrls,
    getYouTubePreviewUrl
}
